import { render, staticRenderFns } from "./ExchangeOfferBids.vue?vue&type=template&id=ea2b621c&"
import script from "./ExchangeOfferBids.vue?vue&type=script&lang=js&"
export * from "./ExchangeOfferBids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports